import React, { memo, useEffect, useState } from 'react'

import { Box, Divider, Flex, Tooltip } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { displayReactIcon } from '../helpers/dsr-display-helpers';
import { RiQuestionFill } from 'react-icons/ri'


function DsrPageSideMenu({
  pageArray,
  altPageNames,
  extraHeaderLayoutOffset,
  selectedDisplaySubpage,
  selectedDisplayPageId,
  handleSelectSubpage,
  isDsrAdmin,
  isSellingTeamMember, // includes everyone in host/selling team
  closeMenuDrawer,
  headerMenuHeight,
  isPagePreviewMode,
  isProspector,
  sideMenuOffsetRequired,
  dsrBrandingOptions,
  applyBranding
}) {

  const [brandColor, setBrandColor] = useState(null);

  useEffect(() => {
    if (dsrBrandingOptions) {
      const { primaryColor } = dsrBrandingOptions || {}
      setBrandColor(primaryColor)
    }
  }, [dsrBrandingOptions]);

  const mutualActionPlanTab = () => {
    const { map: mapAltPageName } = altPageNames || {};
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `action-list-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'action-list-subpage')
          closeMenuDrawer && closeMenuDrawer()
        }}
        gap='1em'
        data-driver="room-tour-step-5"
      >
        <Box color={applyBranding && brandColor}>{displayReactIcon('circle-check', '1em')}</Box>
        <Box lineHeight='1.5em'> {mapAltPageName || "Mutual Action Plan"}</Box>
      </Flex>
    )
  }

  const docFolderTab = () => {
    const { sharedDocs: sharedDocsAltPageName } = altPageNames || {};
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `shared-docs-folder-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'shared-docs-folder-subpage')
          closeMenuDrawer && closeMenuDrawer()
        }}
        gap='1em'
        data-driver="room-tour-step-6"
      >
        <Box color={applyBranding && brandColor}>{displayReactIcon('folder', '1em')}</Box>
        <Box lineHeight='1.5em'>{sharedDocsAltPageName || "Shared Documents"}</Box>
      </Flex>
    )
  }

  const faqTab = () => {
    const { faq: faqAltPageName } = altPageNames || {};
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === `faq-subpage`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'faq-subpage')
          closeMenuDrawer && closeMenuDrawer()
        }}
        gap='1em'
        data-driver="room-tour-step-4"
      >
        <Box color={applyBranding && brandColor}>{displayReactIcon('faq', '1em')}</Box>
        <Box>{faqAltPageName || "Q&A"}</Box>
      </Flex>
    )
  }

  const updatesPageTab = () => {
    return (
      <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
        className={(selectedDisplaySubpage === "updates-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
        onClick={() => {
          handleSelectSubpage("", 'updates-subpage')
          closeMenuDrawer && closeMenuDrawer()
        }}
        gap='1em'
        data-driver="room-tour-step-3"
      >
        <Box color={applyBranding && brandColor}>{displayReactIcon('star', '1em')}</Box>
        <Box lineHeight='1.5em'> Updates</Box>

      </Flex>
    )
  }

  const renderAdminPageTabs = () => {
    return (
      <Box mt='3em' mb={sideMenuOffsetRequired && '3em'}>
        {categoryLabel('ADMINISTRATOR PAGES', 'Info accessible only by Room Administrators')}
        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "insights-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'insights-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
          gap='1em'
        >
          <Box>{displayReactIcon('worktool', '1em')}</Box>
          <Box lineHeight='1.5em'> Insights</Box>

        </Flex>

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "team-notes-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'team-notes-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
          gap='1em'
        >
          <Box>{displayReactIcon('worktool', '1em')}</Box>
          <Box lineHeight='1.5em'> Team Notes</Box>
        </Flex>

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "room-settings-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'room-settings-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
          gap='1em'
        >
          <Box>{displayReactIcon('worktool', '1em')}</Box>
          <Box lineHeight='1.5em'> Settings</Box>

        </Flex>
      </Box>
    )
  }

  const renderHostMemberPageTabs = () => {
    return (
      <Box mt='3em' mb={sideMenuOffsetRequired && '3em'}>
        {categoryLabel('HOST PAGES')}

        <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
          className={(selectedDisplaySubpage === "team-notes-subpage") ? "chosen-subpage-option" : "unchosen-subpage-option"}
          onClick={() => {
            handleSelectSubpage("", 'team-notes-subpage')
            closeMenuDrawer && closeMenuDrawer()
          }}
          gap='1em'
        >
          <Box>{displayReactIcon('worktool', '1em')}</Box>
          <Box lineHeight='1.5em'> Team Notes</Box>
        </Flex>
      </Box>
    )
  }

  const categoryLabel = (labelText, toolTipText) => {
    return (
      <Flex mt='1em' justify='flex-start' align='center' color='gray.500' cursor='default' className='unchosen-subpage-option'>
        <Box fontSize='0.75em' fontWeight='600' whiteSpace='pre'>{labelText}</Box>
        <Tooltip fontSize='0.8em' label={toolTipText} placement="auto-start">
          <Box ml='0.5em'>
            <Box as={RiQuestionFill} boxSize="1em" py='3%' />
          </Box>
        </Tooltip>
      </Flex>
    )
  }

  function renderSubPageTabs(category) {
    if (!pageArray) {
      return null
    }

    let pagesToRender = [];

    if (category === 'essential-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType !== 'customised-page')
    } else if (category === 'custom-pages') {
      pagesToRender = pageArray?.filter(tabs => tabs.pageType === 'customised-page')
    }

    if (pagesToRender) {
      const pageTabs = pagesToRender?.map((tabs, tabIndex) => {
        const { pageId, pageIcon, pageIconColor, altPageTitle, pageTitle, pageType, displayPage, lockedPage } = tabs || {};

        if (displayPage === true) {
          if (pageType === 'customised-page') {
            if (lockedPage) {
              return (
                <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
                  className="locked-subpage"
                >
                  <Flex justify='flex-start' align='center' gap='1em'>
                    <Box color={applyBranding && brandColor}>{displayReactIcon("lock", '1em', displayPage)}</Box>
                    <Box whiteSpace='pre' minW='11em'>{altPageTitle || pageTitle}</Box>
                  </Flex>
                </Flex>
              )
            } else {
              const displayIcon = pageIcon ? pageIcon : pageType;
              const displayIconColor = (applyBranding && brandColor) ? brandColor : pageIconColor ? pageIconColor : 'brandDark.500';

              return (
                <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
                  className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
                  onClick={() => {
                    handleSelectSubpage(pageId, "")
                    closeMenuDrawer && closeMenuDrawer()
                  }}
                >
                  <Flex justify='flex-start' align='flex-start' gap='1em'>
                    <Box mt='0.3em' color={displayIconColor}>{displayReactIcon(displayIcon, '1em', displayPage)}</Box>
                    <Box whiteSpace='pre-wrap' minW='11em'>{altPageTitle || pageTitle}</Box>
                  </Flex>
                </Flex>
              )
            }

          } else {
            // The first page is the default overview page, then also display the updates page alongside it. Let Overview be the first page to show by default.
            if (tabIndex === 0) {
              return (
                <React.Fragment key={`dsr_page_tab_${tabIndex}-${pageId}`}>
                  <Flex justify='flex-start' align='center' px='1.1em' py='0.875em'
                    className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
                    onClick={() => {
                      handleSelectSubpage(pageId, "")
                      closeMenuDrawer && closeMenuDrawer()
                    }}
                    gap='1em'
                    data-driver="room-tour-step-2"
                  >
                    <Box color={applyBranding && brandColor}>{displayReactIcon(pageType, '1em')}</Box>
                    <Box>{altPageTitle || pageTitle}</Box>
                  </Flex>

                  {updatesPageTab()}
                </React.Fragment>
              )

            }
            // else {
            //   // Q&A page
            //   return (
            //     <Flex key={`dsr_page_tab_${tabIndex}-${pageId}`} justify='flex-start' align='center' px='1.1em' py='0.875em'
            //       className={(selectedDisplayPageId === `${pageId}`) ? "chosen-subpage-option" : "unchosen-subpage-option"}
            //       onClick={() => {
            //         handleSelectSubpage(pageId, "")
            //         closeMenuDrawer && closeMenuDrawer()
            //       }}
            //       gap='1em'
            //       data-driver="room-tour-step-4"
            //     >
            //       <Box color={applyBranding && brandColor}>{displayReactIcon(pageType, '1em')}</Box>
            //       <Box>{altPageTitle || pageTitle}</Box>
            //     </Flex>
            //   )
            // }

          }
        } else {
          return null;
        }

        return null
      }
      )

      if (category === 'essential-pages') {
        return (
          <React.Fragment>
            {pageTabs}
            {!isProspector && <>
              {faqTab()}
              {mutualActionPlanTab()}
              {docFolderTab()}
            </>
            }
          </React.Fragment>
        )
      } else if (category === 'custom-pages') {
        if (pageTabs?.length > 0) {
          if (isProspector) {
            return (
              <>
                <Box pt='1.5em'>
                  {pageTabs}
                </Box>
              </>
            )
          } else {
            return (
              <>
                <Box p='1em 25% 1em 20%'>
                  <Divider color='gray.50' />
                </Box>
                <Box data-driver="room-tour-step-7">
                  {pageTabs}
                </Box>
              </>
            )
          }

        } else return null;

      } else return null;
    }

    else return null
  }

  return (
    <Flex
      flexWrap='wrap'
      justify='flex-start'
      pt={extraHeaderLayoutOffset ? '3em' : '2em'}
      position='relative'
      maxWidth='280px'
      height={`calc(100vh - ${headerMenuHeight})`}
      overflowX="hidden"
      overflowY="auto"
      sx={{
        // Hides scrollerbar
        '&::-webkit-scrollbar': { display: 'none' },  // Chrome, Safari, Opera
        '-ms-overflow-style': 'none',                 // IE and Edge
        'scrollbar-width': 'none',                    // Firefox
      }}
    >
      <Flex direction='column' justify='space-between' align='flex-start' maxWidth='fit-content' pb='1em'>
        <Box>
          {/* {updatesPageTab()} */}
          {renderSubPageTabs('essential-pages')}
          {/* {mutualActionPlanTab()} */}

          {renderSubPageTabs('custom-pages')}
        </Box>

        <Box>
          {(isDsrAdmin && !isPagePreviewMode) && renderAdminPageTabs()}
          {(isSellingTeamMember && !isDsrAdmin) && renderHostMemberPageTabs()}
        </Box>
      </Flex>

    </Flex>
  )
}

const mapStateToProps = (state) => {
  return {
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    dsrBrandingOptions: state.dsrBrandingOptions.results,
    applyBranding: state.dsrApplyBranding.results
  }
}


export default memo(withRouter(connect(mapStateToProps, null)(DsrPageSideMenu)))